import { ActionIcon, Group, Overlay, useMantineTheme } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import ResolverImage from "../resolverImage/ResolverImage";
import { IconZoomIn } from "@tabler/icons-react";
import { useState } from "react";
import { AppConstants } from "utils/constants";

const useStyles = createStyles((theme) => ({
  preview: {
    ".overlay": {
      opacity: 0,
    },
    "&:hover": {
      ".overlay": {
        opacity: 0.5,
      },
      ".btn-clear": {
        opacity: 1,
        marginTop: 0,
      },
    },
    ".btn-clear": {
      opacity: 0,
      marginTop: 10,
      transition: "all .2s ease-in-out",
    },
  },
}));

const ImagePreview = ({ file, onClick, height = 200, width = 180, fit="contain" }) => {
  const { classes } = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const theme = useMantineTheme();
  return (
    <Group
      className={classes.preview}
      style={{ position: "relative", minWidth: width, flex:1 }}
      justify="center"
      position="center"
      onClick={() =>
        onClick({ previewHi: file.url, originalFilename: file.name })
      }
    >
      
      <ResolverImage fit={fit} height={height} src={file.url} radius={theme.radius.md} />

      <Overlay className="overlay" color="#000" zIndex={80} />
      <ActionIcon
        variant="filled"
        radius={"xl"}
        size={"md"}
        className="btn-clear"
        color="dark"
        style={{ position: "absolute", zIndex: 100 }}
      >
        <IconZoomIn
          stroke={AppConstants.ICON_STROKE_WIDTH}
          size={AppConstants.ICON_SIZE}
        />
      </ActionIcon>
    </Group>
  );
};

export default ImagePreview;
